import React from "react";

import { CircularProgress } from "@mui/material";

import { ReactComponent as FacebookLogo } from "assets/images/facebook-logo.svg";

import "./index.scss";

const FacebookButton: React.FC<{
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}> = ({ onClick, disabled, loading }) => (
  <button
    data-testid="facebook-button"
    className="facebook-material-button"
    onClick={onClick}
    disabled={disabled || loading}
  >
    <div className="facebook-material-button-state"></div>
    <div className="facebook-material-button-content-wrapper">
      {loading && (
        <CircularProgress
          size={24}
          thickness={10}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: -12,
            marginLeft: -12,
            color: "white",
          }}
        />
      )}

      <div
        className="facebook-material-button-icon"
        style={{ visibility: loading ? "hidden" : "visible" }}
      >
        <FacebookLogo width={20} height={20} />
      </div>
      <span
        className="facebook-material-button-contents"
        style={{ visibility: loading ? "hidden" : "visible" }}
      >
        Продовжити через Facebook
      </span>
      <span style={{ display: "none" }}>Продовжити через Facebook</span>
    </div>
  </button>
);

export default FacebookButton;
